var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Datepicker',{staticClass:"datepicker",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('Timepicker',{staticClass:"timepicker",attrs:{"minuteInterval":_vm.minuteInterval},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }